const R2_DOMAIN = "assets.captcha.social"

/**
 * Build a Cloudflare Image Resizing URL for an R2 object key.
 * For old Convex storage URLs (starting with "http"), returns the URL as-is.
 */
export function r2ImageUrl(
	key: string,
	opts: { width?: number; height?: number; quality?: number } = {},
): string {
	if (key.startsWith("http")) {
		return key
	}

	const params = [
		"format=auto",
		"fit=scale-down",
		opts.width && `w=${opts.width}`,
		opts.height && `h=${opts.height}`,
		`q=${opts.quality ?? 80}`,
	]
		.filter(Boolean)
		.join(",")

	return `https://${R2_DOMAIN}/cdn-cgi/image/${params}/${key}`
}

/** Build a raw R2 public URL (no resizing) for an R2 object key. */
export function r2RawUrl(key: string): string {
	if (key.startsWith("http")) {
		return key
	}
	return `https://${R2_DOMAIN}/${key}`
}
